<template>
  <a-spin :spinning="playerLoading">
    <div class="titleDiv">
      <div class="left">
        <span class="line"></span>
        <span class="title">选择参赛球员</span>
      </div>
      <div style="text-align: right;" v-if="playerData.length > 0">
        <a-button type="primary" size="small" icon="plus" @click="addPlayer">添加球员</a-button>
        <a-dropdown>
          <a-menu slot="overlay">
            <a-menu-item key="1">
              <a-upload
                :showUploadList="false"
                accept=".xls,.xlsx"
                :multiple="false"
                :customRequest="handlerUpload">
                <a-button type="primary" size="small" icon="upload">从表格中导入</a-button>
              </a-upload>
            </a-menu-item>
            <a-menu-item key="2">
              <a :href="importModel()">
                <a-button type="primary" size="small" icon="download">下载表格模板</a-button>
              </a>
            </a-menu-item>
          </a-menu>
          <a-button type="primary" size="small" icon="import">导入球员</a-button>
        </a-dropdown>
      </div>
    </div>
    <div class="contentWarp" v-if="playerData.length > 0">
      <div class="playerDiv" v-for="(player, index) in filterPlayer()" :key="index" @click="playerCheck(player, index)">
        <span class="head">
          <img :src="player.head || defaultHead"/>
          <img class="checkImg" v-if="player.hasChecked === 1" :src="checkedImg">
          <div v-if="combat != null" :class="player['pass'] == true ? 'pass' : 'nopass'">{{ player['pass'] == true ? '条件符合' : '条件不符' }}</div>
        </span>
        <span class="playerMsg">
          <div>姓&nbsp;&nbsp;&nbsp;&nbsp;名：{{ player.name }}</div>
          <div class="marginTop5">球衣号：{{ player.jerseyNumber }}</div>
          <div class="marginTop5">位&nbsp;&nbsp;&nbsp;&nbsp;置：{{ player.location }}</div>
          <a-button type="primary" size="small" style="margin-top: 20px;" @click.stop="editPlayer(player)">编辑资料</a-button>
          <a-popconfirm
            title="确定要删除该学员吗?"
            @confirm="() => delPlayer(player)"
          >
            <a-button type="danger" size="small" style="margin-top: 20px;">删除</a-button>
          </a-popconfirm>
        </span>
      </div>
    </div>
    <div class="emptyWarp" v-if="playerData.length === 0">
      <a-empty
        :image="emptyUser" :image-style="{height: '60px'}">
        <span slot="description"> 暂无球员信息 </span>
        <a-button type="primary" size="small" @click="addPlayer" icon="plus">添加球员</a-button>
        <a-dropdown>
          <a-menu slot="overlay">
            <a-menu-item key="1">
              <a-upload
                :showUploadList="false"
                accept=".xls,.xlsx"
                :multiple="false"
                :customRequest="handlerUpload">
                <a-button type="primary" size="small" icon="upload">从表格中导入</a-button>
              </a-upload>
            </a-menu-item>
            <a-menu-item key="2">
              <a :href="importModel()">
                <a-button type="primary" size="small" icon="download">下载表格模板</a-button>
              </a>
            </a-menu-item>
          </a-menu>
          <a-button type="primary" size="small" icon="import">导入球员</a-button>
        </a-dropdown>
      </a-empty>
    </div>
    <AddBigballPlayer ref="addBigballPlayer" @success="queryPlayerByTeam"></AddBigballPlayer>
    <EditPlayer ref="editPlayer"/>
    <BindPlayerHead ref="bindPlayerHead" @success="bindSuccess"></BindPlayerHead>
  </a-spin>
</template>
<script>
import AddBigballPlayer from '@comm/components/join/player/AddBigballPlayer'
import EditPlayer from './EditPlayer'
import BindPlayerHead from '../player/BindPlayerHead'
export default {
  components: {
    AddBigballPlayer,
    EditPlayer,
    BindPlayerHead
  },
  props: {
    combat: {
      type: Object,
      default: null
    },
    teamId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      playerLoading: false,
      programId: this.$route.query.programId,
      defaultHead: require('@comm/assets/join/photo.png'),
      emptyUser: require('@comm/assets/join/empty_user.png'),
      checkedImg: require('@comm/assets/join/imgCheck.png'),
      playerData: [],
      basketballPlayerModle: 'https://static.daoba.com/impotBasketballPlayer-module.xlsx', // 篮球球员模板
      heighTechBasketballPlayerModld: 'https://static.daoba.com/impotBasketballPlayer-heigh-module.xlsx', // 高新区篮球赛事球员模板
      footballPlayerModle: 'https://static.daoba.com/impotFootballPlayer-module.xlsx', // 足球赛事球员模板
      heighTechFootballPlayerModel: 'https://static.daoba.com/impotFootballPlayer-heigh-module.xlsx', // 高新区足球赛事球员模板
      rugbyPlayerModel: 'https://static.daoba.com/impotRugbyPlayer-module.xlsx', // 橄榄球球员模板
      organisersId: JSON.parse(localStorage.getItem('matchInfo')).agencyId // 赛事主办方id, 如果是高新区的赛事，在添加队员的时候不选择国籍,需要选择人员类别（在职在编人员、文员、聘用人员）
    }
  },
  mounted () {
    this.queryPlayerByTeam()
  },
  methods: {
    // 获取下载的模板
    importModel () {
      // organisersId == 1 ? (programId == 4 ? heighTechFootballPlayerModel : heighTechBasketballPlayerModld) : (programId == 4 ? footballPlayerModle : basketballPlayerModle)
      if (this.organisersId == 1) {
        // 高新区的篮球/足球赛事模板
        if (this.programId == 4) {
          return this.heighTechFootballPlayerModel
        } else {
          return this.heighTechBasketballPlayerModld
        }
      } else {
        if (this.programId == 4) {
          return this.footballPlayerModle
        } else if (this.programId == 5) {
          return this.basketballPlayerModle
        } else {
          return this.rugbyPlayerModel
        }
      }
    },
    addPlayer () {
      if (this.teamId == null) {
        this.$message.error('请先选择一个参赛队伍')
        return
      }
      this.$refs.addBigballPlayer.show()
    },
    handlerUpload (options) {
      if (this.teamId == null) {
        this.$message.error('请先选择一个参赛队伍')
        return
      }
      let formData = new FormData()
      formData.append('file', options.file, 'importBigballPlayer.xlsx')
      let agencyId = this.$route.query.agencyId
      let matchId = this.$route.query.matchId
      this.playerLoading = true
      this.$api.join.importBigballPlayer(agencyId, this.organisersId, this.teamId, matchId, formData).then(res => {
        if (res.status === 0) {
          this.$message.success('导入成功')
          this.queryPlayerByTeam()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log('err', err)
        this.$message.error('导入失败')
      }).finally(_ => {
        this.playerLoading = false
      })
    },
    // 查询队员
    queryPlayerByTeam () {
      if (this.teamId == null) {
        return
      }
      this.playerLoading = true
      let params = this.createParams()
      this.$api.join.queryPlayerByTeam(params).then(res => {
        if (res.status === 0) {
          this.playerData = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log('err', err)
        this.$message.error('队员信息获取失败')
      }).finally(_ => {
        this.playerLoading = false
      })
    },
    createParams () {
      let params = {
        matchId: this.$route.query.matchId,
        combatDetailId: this.combat == null ? -1 : this.combat.combatDetailId,
        agencyId: this.$route.query.agencyId,
        teamId: this.teamId,
        programId: this.$route.query.programId
      }
      return params
    },
    editPlayer (player) {
      this.$refs.editPlayer.show(player)
    },
    delPlayer (player) {
      console.log(player)
      let valData = {
        matchId: this.$route.query.matchId,
        cardId: player.cardId,
        agencyId: this.$route.query.agencyId,
        teamId: this.teamId,
        programId: this.$route.query.programId
      }
      this.$api.join.delPlayerLocation(valData).then(res => {
        if (res.status === 0) {
          this.queryPlayerByTeam()
          this.$message.success('成功')
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log('err', err)
        this.$message.error('失败')
      })
    },
    playerCheck (player, index) {
      // 如果没有头像，则先绑定头像
      if (player.head == null) {
        // 绑定头像
        this.$refs.bindPlayerHead.show(player, index)
        return
      }
      if (this.combat == null) {
        this.$message.error('请选择参赛组别')
        return
      }
      if (player.jerseyNumber == null) {
        this.$message.error('请先录入该队员的球衣号码')
        return
      }
      let pass = player['pass']
      if (!pass) {
        this.$message.error('该队员条件不符')
        return
      }
      player.hasChecked = player.hasChecked === 0 ? 1 : 0
    },
    // 头像绑定成功
    bindSuccess (player) {
      let index = player['index']
      let head = player.head
      this.playerData[index].head = head
    },
    // 根据选择的项目过滤队员
    filterPlayer () {
      if (this.combat == null) {
        return this.playerData
      } else {
        let passPlayers = []
        let noPassPlayers = []
        let minAge = Date.parse(this.combat.minAge.replace(/-/g, '/'))
        let maxAge = Date.parse(this.combat.maxAge.replace(/-/g, '/'))
        let sex = this.combat.sex
        this.playerData.forEach(player => {
          let playerBirthday = Date.parse(player.birthday.replace(/-/g, '/'))
          // console.log(minAge, maxAge, playerBirthday, this.combat.minAge.replace(/-/g, '/'),this.combat.maxAge.replace(/-/g, '/'),player.birthday.replace(/-/g, '/'))
          let playerSex = player.sex
          if (playerBirthday >= minAge && playerBirthday <= maxAge && (playerSex == sex || sex === 0)) {
            player['pass'] = true
            passPlayers.push(player)
          } else {
            player['pass'] = false
            noPassPlayers.push(player)
          }
        })
        let allPlayers = passPlayers.concat(noPassPlayers)
        return allPlayers
      }
    },
    // 获取选中的队员
    getChoicedPlayes () {
      let choicedPlayers = []
      this.playerData.forEach(player => {
        let hasChecked = player.hasChecked
        if (hasChecked === 1) {
          choicedPlayers.push(player)
        }
      })
      return choicedPlayers
    }
  },
  watch: {
    combat (newValue, oldValue) {
      this.queryPlayerByTeam()
    },
    teamId (newValue, oldValue) {
      if (newValue != null) {
        this.queryPlayerByTeam()
      } else {
        this.playerData = []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .titleDiv {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    margin-top: 10px;
    .left {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .line {
      height: 25px;
      width: 5px;
      background-color: #b80000;
    }
    .title {
      font-size: 19px;
      font-weight: bold;
      margin-bottom: 0px;
      margin-left: 10px;
    }
  }
  .contentWarp {
    padding: 10px 0px 0px 10px;
    border: 1px solid #ebedf0;
    display: flex;
    flex-wrap: wrap;
    background: #F1F2F7;
    .playerDiv {
      width: 260px;
      border-radius: 5px;
      background: #fff;
      border: 1px solid #fff;
      padding: 10px;
      margin-right: 20px;
      margin-bottom: 20px;
      cursor: pointer;
      .head {
        position: absolute;
        img {
          height: 110px;
          width: 80px;
          border-radius: 5px;
        }
        div {
          height: 22px;
          width: 60px;
          border-radius: 0px 100px 100px 0px;
          opacity: 0.8;
          margin-top: 4px;
          cursor: pointer;
          position: relative;
          top: -35px;
          color: white;
          font-size: 12px;
          padding-top: 1px;
          text-align: center;
        }
        .pass {
          background: #34c74d;
        }
        .nopass {
          background: #FE4848;
        }
        .checkImg {
          position: relative;
          top: 0;
          left: -84px;
        }
      }
      .playerMsg {
        float: right;
        width: 135px;
        div {
          font-size: 15px;
          font-weight: bold;
        }
        marginTop5 {
          margin-top: 5px;
        }
        marginTop20 {
          margin-top: 20px;
        }
      }
    }
  }
  .emptyWarp {
    min-height: 185px;
    border: 1px solid #ebedf0;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/bigBall/Player.vue